import React, { useEffect, useState } from "react";
import "./VehicleTaskAttachments.css";
import pdf_log from "../../../../../../assets/Pdf_logo.png";
import FormButton from "../../../../../../components/formButton/FormButton";
import { Button, CircularProgress, useTheme } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateVehicleTaskAttachmentIsPublish } from "../../../../../../api/apiServices/vehicleApi";
import ResponseHandler from "../../../../../../services/ResponseHandler";
function VehicleTaskAttachments({ attachments }) {
  const theme = useTheme();
  const { id } = useParams();
  const dispatch = useDispatch();
  const primaryColor = theme.palette.primary.main;
  const [Attachment, SetAttachments] = useState([]);
  const [isPublishedChecked, SetisPublishedChecked] = useState(false);
  const [loading, Setloading] = useState(false);
  useEffect(() => {
    SetAttachments(attachments);
  }, [attachments]);

  function updatePublishedState(index) {
    let referenceAttachment = Attachment.slice(); // Make a shallow copy of the Attachment array
    referenceAttachment[index] = {
      ...referenceAttachment[index], // Copy the existing properties of the attachment
      isPublish: !referenceAttachment[index].isPublish, // Toggle the isPublish property
    };

    SetAttachments(referenceAttachment);
  }

  const Privilages = useSelector((state) => state.userStore.Privilages);
  return (
    <div className="vehicle_task_attachment_main_base_container">
      <p className="vehicle_task_attachment_title">Attachment</p>
      <div className={"vehicle_task_attachment_main_container"}>
        <div className="vehicle_task_attachment_sub_container">
          {Attachment &&
            Attachment.map((item, index) => {
              return (
                ["pdf", "doc", "docx", "txt"].includes(item.filetype) && (
                  <div
                    key={index}
                    className="vehicle_task_file_attachment_container"
                  >
                    <div className="vehicle_task_file_attachment_sub_container">
                      {Privilages &&
                      Privilages?.Vehicle &&
                      Privilages?.Vehicle.some((item) => item === "Update") ? (
                        <input
                          type="checkbox"
                          checked={item.isPublish}
                          onChange={() => updatePublishedState(index)}
                        />
                      ) : null}

                      <img src={pdf_log} />
                    </div>
                    <p>{item.title}</p>
                  </div>
                )
              );
            })}
        </div>
        <div className="vehicle_task_attachment_sub_container">
          {Attachment &&
            Attachment.map((item, index) => {
              return (
                !["pdf", "doc", "docx", "txt"].includes(item.filetype) && (
                  <div key={index}>
                    <div className="vehicle_task_image_attachment_container">
                      {Privilages &&
                      Privilages?.Vehicle &&
                      Privilages?.Vehicle.some((item) => item === "Update") ? (
                        <input
                          type="checkbox"
                          checked={item.isPublish}
                          onChange={() => updatePublishedState(index)}
                        />
                      ) : null}

                      <img
                        className="vehicle_task_image_attachment"
                        src={item.file}
                      />
                    </div>
                    <p className="vehicle_task_image_title">{item.title}</p>
                  </div>
                )
              );
            })}
        </div>
      </div>
      {Privilages &&
        Privilages?.Vehicle &&
        Privilages?.Vehicle.some((item) => item === "Update") && Privilages.url_role!=="Runner" ? (
      <div className="vehicle_task_publish_action_footer">
          <>
            <div className="vehicle_task_publish_action_checkbox">
              <input
                type="checkbox"
                value={isPublishedChecked}
                onChange={(e) => SetisPublishedChecked(e.target.checked)}
              />
              <p>Publish files</p>
            </div>
            <Button
              disableElevation
              variant={"contained"}
              size="small"
              style={{ textTransform: "none", lineHeight: 1.5 }}
              disabled={!isPublishedChecked || loading}
              sx={{
                "&.Mui-disabled": {
                  background: primaryColor,
                  color: theme.palette.getContrastText(primaryColor),
                },
              }}
              onClick={() => {
                Setloading(true);
                dispatch(updateVehicleTaskAttachmentIsPublish(id, Attachment))
                  .then((response) => {
                    ResponseHandler(response);
                  })
                  .catch((error) => {
                    ResponseHandler(error);
                  })
                  .finally(() => {
                    Setloading(false);
                  });
              }}
            >
              {loading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          </>
      </div>
       ) : <></>}
    </div>
  );
}

export default VehicleTaskAttachments;
